import { render } from "./OrderEditItem.vue?vue&type=template&id=4640ebbb"
import script from "./OrderEditItem.vue?vue&type=script&lang=js"
export * from "./OrderEditItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__